import frErrors from './fr/errors.json';
import frValidation from './fr/validation.json';
import frBusiness from './fr/business.json';

import enErrors from './en/errors.json';
import enValidation from './en/validation.json';
import enBusiness from './en/business.json';

const fr = {
  ...frErrors,
  ...frValidation,
  ...frBusiness,
};

const en = {
  ...enErrors,
  ...enValidation,
  ...enBusiness,
};

export const errorTranslations = {
  fr,
  en,
};
